import ScorecardMyBeginComponent from "./ScorecardMyBeginComponent";
import EventScorecardNotLoggedIn from "./EventScorecardNotLoggedIn";
import { useRouter } from "../util/router";

function EventScorecardsMy({
  isLoggedIn,
  uid,
  eventId,
  isEventComplete,
  auth,
  canCheckIn,
  isCheckedInAlready,
  isIncompleteCards,
  gameId,
  throwScoringModeId,
}) {
  const router = useRouter();

  return (
    <>
      {isLoggedIn ? (
        <ScorecardMyBeginComponent
          isIncompleteCards={isIncompleteCards}
          isCheckedInAlready={isCheckedInAlready}
          canCheckIn={canCheckIn}
          isEventComplete={isEventComplete}
          eventId={eventId}
          isLoggedIn={isLoggedIn}
          userId={uid}
          auth={auth}
          gameId={gameId}
          throwScoringModeId={throwScoringModeId}
        />
      ) : (
        <EventScorecardNotLoggedIn eventId={eventId} router={router} />
      )}
    </>
  );
}

export default EventScorecardsMy;
